import React, { useEffect, useState } from 'react';
import ISOCHROOUS_TYPES from '@core/constants/isochronous/types';
import { LightGreySubtitleColor } from '@core/theme/baseTheme';
import IsochronousColors from '@core/theme/map.colors';
import Typography from '@mui/material/Typography';
import { useLanguage } from 'Context/LanguageContext';
import IsochronousShape from '~/IsochronousShape/IsochronousShape.component';
import { useJsApiLoader } from '@react-google-maps/api';
import { mapConfig } from 'Utils/map/googleMaps.config';

function CellIsochronous({ isochronous }) {
	const { id, radius, vertices, name, type } = isochronous;
	const { isLoaded, loadError } = useJsApiLoader(mapConfig);
	const lan = useLanguage();
	const selectedColor = IsochronousColors[id % IsochronousColors.length];
	const [radiusText, setRadiusText] = useState('');
	useEffect(() => {
		let area;
		if (!isochronous) return;
		if (type === ISOCHROOUS_TYPES.CIRCLE) {
			area = Math.PI * Math.pow(radius, 2);
		} else {
			console.log(google.maps, window.google);
			area = window.google.maps?.geometry?.spherical?.computeArea(vertices);
		}
		if (area && area > 1000000) {
			const areaKilometers = area / 1000000;
			setRadiusText(`${lan.area}: ${Intl.NumberFormat().format(areaKilometers.toFixed(1))} km²`);
		} else setRadiusText(`${lan.area}: ${area?.toFixed(1)} m²`);
	}, [type, radius, lan]);
	if (isLoaded) {
		return (
			<div style={{ display: 'flex' }}>
				<div>
					<IsochronousShape color={selectedColor} vertices={vertices} width='100px' />
				</div>
				<div style={{ flex: '0 1 auto' }}>
					<Typography style={{ fontSize: '12pt', fontFamily: 'Lato' }}>{name}</Typography>
					<Typography style={{ color: LightGreySubtitleColor, fontSize: '10pt', fontFamily: 'Lato' }}>
						{radiusText}
					</Typography>
				</div>
			</div>
		);
	}
	return <></>;
}

export default CellIsochronous;
